// Different types of trains.
enum TrainType {
  Local = 'Local',
  Limited = 'Limited',
  Bullet = 'Bullet',
}

export default TrainType;
